module.exports = __webpack_public_path__ + "img/20190614161941855.c4d35ca4.png";